import React from 'react';
import SingleProject from './SingleProject';
import useProjects from '../hooks/useProjects';

const Projects = () => {
    const [projects] = useProjects();
    return (
        <div>
            <h3 className='text-3xl font-bold text-center text-white my-5 font-mono'>PROJECTS</h3>
            <div className='grid grid-cols-1 lg:grid-cols-3 gap-4 place-items-center'>
                {
                    projects.map((p) => <SingleProject key={p.id} {...p}></SingleProject>)
                }
            </div>
        </div>
    );
};

export default Projects;